var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeLaLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 79,
    viewBox: "0 0 130 79",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5954 39.1776C41.5364 30.3399 42.9505 21.6201 45.7785 13.2538C47.8996 8.48147 45.7196 2.94321 40.9473 0.822177C36.2339 -1.29886 30.6367 0.822176 28.5746 5.59451C28.0443 6.83178 27.7497 8.12797 27.7497 9.48308C27.7497 10.7793 27.9854 12.0755 28.5156 13.2538C31.2848 21.5023 32.6988 30.1632 32.6988 38.883C32.7577 47.7206 31.3437 56.4405 28.5156 64.8068C26.4535 69.5791 28.6335 75.1174 33.4058 77.1795C34.5842 77.7097 35.8214 77.9454 37.1176 77.9454C42.3024 77.9454 46.5444 73.7033 46.5444 68.5186C46.5444 67.2224 46.2499 65.9851 45.7785 64.8068C43.0094 56.5583 41.5954 47.8974 41.5954 39.1776Z",
    fill: "url(#paint0_linear_621_955)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42683 29.6328C4.24207 29.6328 0 33.8749 0 39.0596C0 44.2444 4.24207 48.4865 9.42683 48.4865C14.6116 48.4865 18.8537 44.2444 18.8537 39.0596C18.8537 33.816 14.6116 29.6328 9.42683 29.6328Z",
    fill: "url(#paint1_linear_621_955)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4411 0.0563965C87.2563 0.0563965 83.0143 4.29847 83.0143 9.48322C83.0143 10.7794 83.3088 12.0167 83.7802 13.195C89.3774 29.9277 89.3774 48.0154 83.7802 64.748C81.6591 69.5203 83.7802 75.0586 88.5525 77.1796C93.3249 79.3007 98.8631 77.1796 100.984 72.4073C101.514 71.17 101.809 69.8738 101.809 68.5187C101.809 67.2225 101.573 65.9264 101.043 64.748C95.4459 48.0154 95.4459 29.9277 101.043 13.195C103.105 8.42271 100.925 2.88444 96.1529 0.822326C95.0335 0.350985 93.7373 0.0563965 92.4411 0.0563965Z",
    fill: "url(#paint2_linear_621_955)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3524 52.3752L73.2935 52.3163C72.8222 51.3147 72.233 50.372 71.4081 49.5471C69.1103 46.1888 66.8715 42.6538 66.8715 38.942C66.8715 35.2301 69.1103 31.8129 71.3492 28.5135C72.1741 27.6887 72.8222 26.746 73.2935 25.7444L73.3524 25.6855C75.4735 20.9131 73.2935 15.3749 68.5212 13.2538C63.7488 11.1328 58.2106 13.3128 56.0895 18.0851C55.029 20.5007 55.029 23.2699 56.0895 25.7444L56.1485 25.8033C56.6198 26.8049 57.209 27.7476 57.9749 28.5135C60.2727 31.8718 62.5116 35.4069 62.5116 39.1187C62.5116 42.8305 60.2727 46.2477 58.0338 49.5471C57.209 50.372 56.5609 51.3147 56.1485 52.3163L56.0895 52.3752C53.9685 57.1475 56.1485 62.6858 60.9208 64.8068C65.6931 66.9279 71.2314 64.7479 73.3524 59.9756C74.4129 57.5599 74.4129 54.7908 73.3524 52.3752Z",
    fill: "url(#paint3_linear_621_955)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.192 29.6328C115.008 29.6328 110.766 33.8749 110.766 39.0596C110.766 44.2444 115.008 48.4865 120.192 48.4865C125.377 48.4865 129.619 44.2444 129.619 39.0596C129.619 33.8749 125.377 29.6328 120.192 29.6328Z",
    fill: "url(#paint4_linear_621_955)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_621_955",
    x1: -4.23581,
    y1: 38.0835,
    x2: 150.329,
    y2: 41.4419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12C781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#63E9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09A9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_621_955",
    x1: -4.24832,
    y1: 38.7395,
    x2: 150.316,
    y2: 42.0979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12C781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#63E9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09A9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_621_955",
    x1: -4.20848,
    y1: 36.9673,
    x2: 150.35,
    y2: 40.3256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12C781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#63E9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09A9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_621_955",
    x1: -4.21854,
    y1: 37.521,
    x2: 150.34,
    y2: 40.8852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12C781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#63E9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09A9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_621_955",
    x1: -4.19484,
    y1: 36.3339,
    x2: 150.37,
    y2: 39.6922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12C781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#63E9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09A9CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeLaLogoIcon);
export default __webpack_public_path__ + "static/media/HeLaLogoIcon.a326b6639dd543fe98a05fbd0e9ec506.svg";
export { ForwardRef as ReactComponent };